<h4 class="mb-0 d-flex align-items-center">{{translate.getLng('DISTANCE')}} &nbsp;<mat-icon matSuffix
        class="sen-cursor-pointer" [autoClose]="'outside'" #distancePopUp="ngbPopover"
        [ngbPopover]="distanceInformation" placement="left">info
    </mat-icon>
</h4>
<mat-radio-group fxLayout="column" [(ngModel)]="selectedElement">
    <mat-radio-button disableRipple fxLayout="row" fxLayoutAlign="center center" [value]="distanceFirstElement"
        class="mt-2">
        <label class="text-nowrap mb-0">{{translate.getLng('BEAM_DIST_FIRST')}}</label>
        <input (focus)="selectedElement = distanceFirstElement" fxFlex="1 1 20%" type="number"
            (change)="nsDist1_changeHandler()" class="mx-2 border-bottom border-dark text-right" min="0" max="100"
            matInput [(ngModel)]="nsDist1_value">
        <span class="sen-fs10">{{translate.getLng('UNIT_CM')}}</span>
    </mat-radio-button>
    <mat-radio-button disableRipple fxLayout="row" fxLayoutAlign="center center" [value]="distanceLastElement"
        class="mt-2">
        <label class="text-nowrap mb-0">{{translate.getLng('BEAM_DIST_LAST')}}</label>
        <input (focus)="selectedElement = distanceLastElement" fxFlex="1 1 20%" type="number"
            (change)="nsDist2_changeHandler()" class="mx-2 border-bottom border-dark text-right" min="0" max="100"
            matInput [(ngModel)]="nsDist2_value">
        <span class="sen-fs10">{{translate.getLng('UNIT_CM')}}</span>
    </mat-radio-button>
</mat-radio-group>
<hr class="border-white">
<h4 class="mb-0 d-flex align-items-center">{{translate.getLng('BEAM_DIVISION')}} &nbsp;<mat-icon matSuffix
        class="sen-cursor-pointer" [autoClose]="'outside'" #beamPopUp="ngbPopover" [ngbPopover]="beamInformation"
        placement="left">
        info</mat-icon>
</h4>
<mat-radio-group fxLayout="column" [(ngModel)]="selectedR_P" class="sen-align-row">
    <mat-radio-button disableRipple fxLayout="row" fxLayoutAlign="center center" [value]="distanceRafter" class="mt-2">
        <label class="text-nowrap mb-0">{{beamType}}</label>
        <input type="number" (focus)="selectedR_P = distanceRafter"
            class="w-25 mx-2 text-right border-bottom border-dark" min={{beamMinMax.nDistMin}}
            max={{beamMinMax.nDistMax}} matInput value={{nsDist_value}} (change)="nsDist_changeHandler($event)">
        <span class="sen-fs10">{{translate.getLng('UNIT_CM')}}</span>
    </mat-radio-button>
    <mat-radio-button disableRipple fxLayout="row" fxLayoutAlign="center center" [value]="numberOfRafter_Purlin"
        class="mt-2">
        <label
            class="text-nowrap mb-0">{{beamType == translate.getLng('RAFTER_DISTANCE') ? translate.getLng('BEAM_AMOUNT_RAFTER') : translate.getLng('BEAM_AMOUNT_PURLIN')}}</label>
        <input type="number" (focus)="selectedR_P = numberOfRafter_Purlin"
            class="w-25 mx-2 border-bottom text-right border-dark" min={{nsAmount_minimum}} max={{nsAmount_maximum}}
            matInput value={{nsAmount_value}} (change)="nsAmount_changeHandler($event)">
        <span class="sen-fs10">{{translate.getLng('UNIT_PIECE')}}</span>
    </mat-radio-button>
</mat-radio-group>

<ng-template #distanceInformation>
    <div fxLayout="row" fxLayoutAlign="center center">
        <div class="mr-3">
            <img src="{{imagePath.DISTANCE_INFO}}">
        </div>
        <div [innerHTML]="translate.getLng('DISTANCE_INFO')"></div>
    </div>
</ng-template>

<ng-template #beamInformation>
    <div fxLayout="row" fxLayoutAlign="center center">
        <div class="mr-3">
            <img src="{{imagePath.BEAM_DISTANCE_INFO}}">
        </div>
        <div [innerHTML]="translate.getLng('BEAM_DISTANCE_INFO')"></div>
    </div>
</ng-template>